export const ESIG_RENTAL_NOTICE = [
  '',
  'Rental Notes',
  'Upon Shipment of your equipment at your location(s):',
  '• You will receive a Schedule to the Master Agreement which includes your monthly rental payment for that location.',
  '• The Schedule will come from Sangoma Technologies via Adobe Acrobat Sign <echosign@echosign.com>, please be sure to add this to your approved senders list to avoid any delays.',
  '• The Schedule must be signed in order to finalize the terms of the Rental.',
  '• If this order includes multiple locations, you will receive a schedule for each location upon shipment of each site.',
].join('\n');
